<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Farm</a></li>
          <li><a>Weekly Growth Summary Report</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home" alt=""></a>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="page-header">
        <span class="page-header__title">Weekly Growth Summary Report</span>
      </div>
      <div class="Reports_form_div">
        <form class="form-horizontal" id="myForm" novalidate [formGroup]="registerForm">
          <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
            <!--Business Field-->
            <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                     placeholder="Search business" (keyup)="filterBusinesses($event)"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = businesses"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(formSubmitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                <i *ngIf="f.businessfield.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!--Location Name Field-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false"
                          [(ngModel)]="farmsiteModel.id" (selectionChange)="getSectionsByFarmSiteID(farmsiteModel.id)">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmsites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
              <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
              <mat-error *ngIf="(formSubmitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                <i *ngIf="f.locationField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
          </div>
        </form>
        <div class="buttons-div reports_search_div">
          <div class="transactions-button-container" (click)="getWeeklyGrowthSummary()">
            <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
              <span class="icon"><img src="../../../../../../../assets/images/New_Icons/search-icon.svg" alt=""></span>
              <span class="text">Search</span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="enableDisableDataLoader">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
       <div class="reports_block" *ngIf="dupWeeklyGrowthReportsData && dupWeeklyGrowthReportsData.length > 0 && isSubmitClicked">
        <div class="actions-container">
          <div class="search-div">

            <button *ngIf="this.search != ''"  type="button" (click)="clearFilters('search')" title="clear search" class="searchClose">&times;</button> -->
          </div>
          <diV class="filters_div">
            <span class="filter_label">By Filter</span>
            <div class="form-field custom-select">
              <select class="form-control select" id="sections" [(ngModel)]="sectionModel.id"
                      placeholder="" (change)="sectionFilterApplied = true;onFiltersApplied()">
                <option value="undefined" selected disabled>Select Section</option>
                <option value="{{section.id}}" *ngFor="let section of sections">
                  {{ section.section_name }}
                </option>
              </select>
              <span class="custom-arrow" *ngIf="!sectionFilterApplied"></span>
              <button (click)="clearFilters('')" title="clear Filters" class="searchClose filtersClose"
                      *ngIf="sectionFilterApplied">&times;
              </button>
            </div>
          </diV>
          <div class="action-icons" *ngIf="weeklyGrowthReportsData && weeklyGrowthReportsData.length > 0">
            <img src="../../../../assets/images/New_Icons/excel-download-icon.svg" title="Excel downlaod" alt=""
                 (click)="exportExcel()">
            <img src="../../../../assets/images/New_Icons/expand-icon.svg" title="Zoom in" alt=""
                 (click)="openFullScreen()">
          </div>
        </div>
        <div *ngIf="weeklyGrowthReportsData && weeklyGrowthReportsData.length > 0">
          <div class="table-responsive" id="zoomView" *ngFor="let lists of weeklyGrowthReportsData">
            <div class="title-div">
              <span>Section: </span><span class="section-name-title">{{ lists.section_name }}</span>
            </div>
            <table class="table table-striped table-bordered table-hover text-centre">
              <thead>
              <tr>
                <th>S.No</th>
                <th>Pond Name/count</th>
                <th>DOC</th>
                <th>Brood Code</th>
                <th>Stocked (L)</th>
                <th>Stock Density (m2)</th>
                <th>Present ABW (G)</th>
                <th>Previous ABW(G)</th>
                <th>Week Growth</th>
                <th>Count</th>
                <th>Present Biomass (Kg)</th>
                <th>C.F (Kg)</th>
                <th>FCR</th>
                <th>Partial Biomass (Kg)</th>
                <th>Partial Number (L)</th>
                <th>SR (%)</th>
                <th>Day Feed (Kg)</th>
                <th>Week Feed (Kg)</th>
                <th>Week Biomass (Kg)</th>
                <th>Week FCR</th>
                <th>Remarks</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let list of lists.raw_data; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ list.pond_name }}</td>
                <td class="number-align-right">{{ list.doc }}</td>
                <td>{{ list.brood_code }}</td>
                <td class="number-align-right">{{ list.stocking_count }}</td>
                <td class="number-align-right">{{ list.stocking_density }}</td>
                <td class="number-align-right">{{ list.present_ABW }}</td>
                <td class="number-align-right">{{ list.previous_ABW }}</td>
                <td class="number-align-right">{{ list.week_growth }}</td>
                <td class="number-align-right">{{ list.count }}</td>
                <td class="number-align-right">{{ list.present_biomass }}</td>
                <td class="number-align-right">{{ list.cumulative_feed }}</td>
                <td class="number-align-right">{{ list.fcr }}</td>
                <td class="number-align-right">{{ list.partial_biomass }}</td>
                <td class="number-align-right">{{ list.partial_number }}</td>
                <td class="number-align-right">{{ list.survival_rate }}</td>
                <td class="number-align-right">{{ list.day_feed }}</td>
                <td class="number-align-right">{{ list.week_feed }}</td>
                <td class="number-align-right">{{ list.week_biomass }}</td>
                <td class="number-align-right">{{ list.week_fcr }}</td>
                <td>{{ list.remarks }}</td>
              </tr>
              <tr>
                <td colspan="20">Section Aggregation Count</td>
              </tr>
              <tr>
                <td>{{ lists.aggregate_data.pond_count }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.doc }}</td>
                <td></td>
                <td class="number-align-right">{{ lists.aggregate_data.stocking_count }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.stocking_density }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.present_ABW }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.previous_ABW }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.week_growth }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.count }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.present_biomass }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.cumulative_feed }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.fcr }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.partial_biomass }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.partial_number }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.survival_rate }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.day_feed }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.week_feed }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.week_biomass }}</td>
                <td class="number-align-right">{{ lists.aggregate_data.week_fcr }}</td>
                <td></td>
              </tr>
              </tbody>
            </table>
            <div *ngIf="NoDataMessage" class="noDataFoundMessage">No Data Available</div>
          </div>
        </div>
        <div *ngIf="weeklyGrowthReportsData && weeklyGrowthReportsData.length <= 0" class="noDataFoundMessage">
          Data Not Found
        </div>
      </div>
      <div class="reports_block"
           *ngIf="dupWeeklyGrowthReportsData && dupWeeklyGrowthReportsData.length <= 0 && isSubmitClicked">
        <div class="noDataFoundMessage">Data Not Available</div>
      </div>
    </div>
  </div>
</div>
